import * as uuid from 'uuid';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Background, BackgroundType, Design, Placement, Size, SizeType } from '../designConstants';
import { ToggleSwitch } from '../ToggleSwitch/ToggleSwitch';

interface AdminLockToggleProps {
  checked: boolean;
  onChange: () => void;
  className?: string;
  disabled?: boolean;
  background?: BackgroundType;
  size?: SizeType;
}

export const AdminLockToggle = ({
  checked,
  onChange,
  className,
  disabled = false,
  background = Background.DARK,
  size = Size.MD
}: AdminLockToggleProps) => (
  <OverlayTrigger
    overlay={
      <Tooltip id={uuid.v4()}>
        If Admin Lock is turned on, only admin users will be able to edit this preset.
      </Tooltip>
    }
    placement={Placement.BOTTOM}
  >
    <div>
      <ToggleSwitch
        design={Design.NEUTRAL}
        background={background}
        label='Admin Lock'
        checked={checked}
        onChange={onChange}
        className={className}
        disabled={disabled}
        size={size}
      />
    </div>
  </OverlayTrigger>
);
